(() => {
    const newsEl = document.querySelector('#newsletter')
    if(newsEl)  {
      const blogImageEl = newsEl.querySelector('.blog-image')
      const blogCategoryEl = newsEl.querySelector('.blog-cat')
      const blogTitleEl = newsEl.querySelector('.blog-title')
      const blogAuthorEl = newsEl.querySelector('.blog-auth') 
      const blogDateEl = newsEl.querySelector('.blog-date')
      const language = window.pageData.language
      fetch(
      `/blogs-staticassets/${language}/similar-posts.json`)
      .then(function (data) {
        return data.json()
      })
      .then(function ([{author, date, featured_image, title, url, category_name}]) {
          blogDateEl.innerText = date
          blogAuthorEl.innerText = author
          blogTitleEl.innerText = title
          blogTitleEl.href = url
          blogCategoryEl.innerText = category_name[0]
          blogImageEl.src = featured_image
          blogImageEl.setAttribute("data-lazyload-mobile-desktop-src",featured_image); 
      })
    }

    const blogReadMore = document.querySelectorAll('.blog-read-more')
    const dateDifferenceInMonths = (dateInitial) => {
      const dateNow = new Date()
      return Math.max(
        (dateNow.getFullYear() - dateInitial.getFullYear()) * 12 +
        dateNow.getMonth() - dateInitial.getMonth(),
        0
      );
    }
    blogReadMore?.forEach((blog)=>{
      let dateEle = blog?.getAttribute('data-blogdate')
      const dateBlog = new Date(dateEle)
      let difference = dateDifferenceInMonths(dateBlog)
      if(difference<=6){
        blog?.classList?.remove('d-none')
      }
    })
  })()